<template>
  <div class="phone-box">
    <img src="@static/images/appointment/phone2.png" alt="">
    <div class="title-text">预约顾问</div>
    <div class="content">
      <!-- <img src="@static/images/appointment/banner.png" class="banner"> -->
      <img :src="config.banner" class="banner">
      <div class="form-box">
        <template v-for="(bean) in list">
          <div class="form-item"  :key="bean.filed" v-if="bean.type==1">
            <label>{{bean.name}}</label>
            <input type="text" placeholder="请输入" v-model="bean.value">
            <div class="code-btn" v-if="bean.filed=='code'">获取验证码</div>
          </div>
          <div class="form-item one-line"  :key="bean.filed" v-if="bean.type==2">
            <label>{{bean.name}}</label>
            <ul class="radio-box">
              <li v-for="(text,key) in getDicList(bean.dict)" :key="key">{{text}}</li>
            </ul>
          </div>
          <div class="form-item"  :key="bean.filed" v-if="bean.type==3">
            <label>{{bean.name}}</label>
            <ul class="check-box">
              <!-- :class="{'active':key==1}" -->
              <li v-for="(text,key) in getDicList(bean.dict)" :key="key">{{text}}</li>
            </ul>
          </div>
        </template>
      </div>
      <Button type="primary" class="submit-btn">提交预约</Button>
      <div class="text-info">您的信息仅作为接受预约顾问使用，您的信息将被严格保密</div>
     
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  mixins:[],
  props: {
    config:{
      default:()=>({})
    },
    list:{
      default:()=>([])
    },
  },
  data() {
    return {
      dic:{},
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.dic = JSON.parse(localStorage.getItem("dic"))
  },
  methods: {
    getDicList(key){
      return this.dic[key]
    }
  },

};
</script>
<style lang="scss" scoped>
@import "./phone.scss";
</style>
